import BalanceRuleModel from "./BalanceRuleModel.js";
import ManualEntryRuleModel from "./ManualEntryRuleModel.js";
import ManualJournalEntryRuleModel from "./ManualJournalEntryRuleModel.js";
import ModelFactory from "../../ModelFactory.js";
import predictionRuleModelFactory from "./predictionModel/PredictionRuleModelFactory.js";

/**
 * Materialize instances of `AbstractRuleModel`.
 */
class RuleModelFactory extends ModelFactory {
	allClasses() {
		return [
			BalanceRuleModel,
			ManualJournalEntryRuleModel,
			ManualEntryRuleModel,
			...predictionRuleModelFactory.allClasses(),
		];
	}
}

export default new RuleModelFactory();
